module.exports = __webpack_public_path__ + "img/8297ad84c10a4b15bd122385abe4d0fc.00b818c2.png";